import JobTitleDto from 'common/dto-types/contacts/job-title-dto';
import ListWithTotal from 'common/dto-types/list-with-total-dto';
import axiosServices, { buildQueryParams, PaginationAndFiltersParams } from 'utils/axios';

const JOB_TITLES_API_URL = 'jobTitles';

export const fetchJobTitleList = async (
    params: PaginationAndFiltersParams,
): Promise<ListWithTotal<JobTitleDto> | null | undefined> => {
    try {
        const res = await axiosServices.get(`${JOB_TITLES_API_URL}${buildQueryParams(params)}`);
        return res.data;
    } catch (err) {
        // TODO: Implement a proper way to handle errors
        // https://fifadigital.atlassian.net/browse/FMH-2075
        console.error(err);
        return null;
    }
};

export const createJobTitle = async (jobTitle: JobTitleDto): Promise<number | null | undefined> => {
    try {
        return await axiosServices.post(JOB_TITLES_API_URL, jobTitle).then((res) => res.data);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const updateJobTitle = async (jobTitle: JobTitleDto): Promise<number | null | undefined> => {
    try {
        return await axiosServices.put(JOB_TITLES_API_URL, jobTitle).then((res) => res.data);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const deleteJobTitle = async (id: string): Promise<number | null> => {
    try {
        return await axiosServices.delete(`${JOB_TITLES_API_URL}/${id}`).then((res) => res.status);
    } catch (err) {
        console.error(err);
        return null;
    }
};
